export enum ProductUploadType {
  Core = 1,
  Exclusive = 2,
}
